export function isUrlBlog(url: URL): boolean {
    const pathname = url.pathname;

    if (pathname.startsWith('/artigos')) {
        return true;
    }

    const regex = /\/([^/]+)\/artigos/;
    return regex.test(pathname);
}